import { motion } from 'framer-motion';
import { ArrowLeft, Eye, PenLine, Wrench } from 'lucide-react';
import { useActiveChild } from '../context/ActiveChildContext';

const TONE = {
  work_as: { colour: '#f59e0b', Icon: PenLine },
  setup_for: { colour: '#34d399', Icon: Wrench },
  view: { colour: '#818cf8', Icon: Eye },
};

/**
 * A parent working on a child can get back to their own FuturePath from anywhere, including the
 * full-screen flows that have no sidebar. Being stranded inside a child's account is the bug this
 * exists to prevent.
 */
export const SubjectExitPill = () => {
  const { isSelf, activeSubject, switchSubject } = useActiveChild();
  if (isSelf || !activeSubject) return null;

  const tone = TONE[activeSubject.mode] || TONE.view;
  const { Icon } = tone;
  const first = activeSubject.name?.split(' ')[0] || 'them';

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
      className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[70] print:hidden"
      data-testid="subject-exit-pill">
      <div className="flex items-center gap-3 rounded-full border backdrop-blur-xl px-4 py-2 shadow-2xl"
        style={{ borderColor: `${tone.colour}66`, background: 'rgba(2,6,23,0.88)' }}>
        <Icon className="w-3.5 h-3.5 shrink-0" style={{ color: tone.colour }} />
        <span className="text-xs text-slate-200">
          {activeSubject.mode === 'view' ? `Viewing ${first}'s FuturePath`
            : `Working as ${first}`}
        </span>
        <button onClick={() => switchSubject(null)} data-testid="subject-exit-pill-back"
          className="inline-flex items-center gap-1 rounded-full bg-white/10 hover:bg-white/20 px-3 py-1 text-xs text-white transition-colors">
          <ArrowLeft className="w-3 h-3" /> back to mine
        </button>
      </div>
    </motion.div>
  );
};

export default SubjectExitPill;
